import { useTranslation } from 'react-i18next';
import { HEALTHCARE_POI_TYPES } from '@/domains/traffic-monitoring/constants/healthcarePoi.constant';
import { cn } from '@/lib/utils';

interface HealthcarePoiLegendProps {
  className?: string;
}

/**
 * Key for the per-type healthcare POI badges on the PSC dashboard map
 * (Hospital / Public Health Center / Clinic / Other). Static - it explains the
 * icons and filters nothing.
 */
const HealthcarePoiLegend = ({ className }: HealthcarePoiLegendProps) => {
  const { t } = useTranslation();

  return (
    // Figma: 12px between rows; each row is a 22px icon, 12px gap, label.
    <div className={cn('flex flex-col gap-3', className)}>
      <span className="body2medium uppercase text-db-text">
        {t('psc>map>healthcare poi layers', { defaultValue: 'Healthcare POI Layers' })}
      </span>
      {HEALTHCARE_POI_TYPES.map((type) => (
        <div key={type.code} className="flex items-center gap-3">
          <img src={type.icon} alt="" className="w-[22px] h-[22px] shrink-0" />
          <span className="flex-1 text-[12px] leading-[130%] text-text-grey dark:text-white">
            {t(type.labelTag, { defaultValue: type.defaultLabel })}
          </span>
        </div>
      ))}
    </div>
  );
};

export default HealthcarePoiLegend;
